import axiosInstance from './axiosInstance';

const getLeaderboardByTournament = async (tournamentId, page = 0, size = 25) => {
  const res = await axiosInstance.get('/leaderboard', {
    params: { tournamentId, page, size },
  });
  const data = res.data;
  if (data && Array.isArray(data.content)) {
    return {
      items: data.content,
      total: typeof data.totalElements === 'number' ? data.totalElements : data.content.length,
      page: typeof data.number === 'number' ? data.number : page,
      size: typeof data.size === 'number' ? data.size : size,
    };
  }
  const arr = Array.isArray(data) ? data : [];
  return { items: arr, total: arr.length, page, size };
};

const getMonthlyLeaderboard = async (tournamentId, year, month, page = 0, size = 25) => {
  const res = await axiosInstance.get('/leaderboard/monthly', {
    params: { tournamentId, year, month, page, size },
  });
  const data = res.data;
  if (data && Array.isArray(data.content)) {
    return {
      items: data.content,
      total: typeof data.totalElements === 'number' ? data.totalElements : data.content.length,
      page: typeof data.number === 'number' ? data.number : page,
      size: typeof data.size === 'number' ? data.size : size,
    };
  }
  const arr = Array.isArray(data) ? data : [];
  return { items: arr, total: arr.length, page, size };
};

const getAvailableMonths = async (tournamentId) => {
  try {
    const res = await axiosInstance.get('/leaderboard/available-months', {
      params: { tournamentId },
    });
    return res.data || [];
  } catch (error) {
    console.error('Error fetching available months:', error);
    return [];
  }
};

// Turnaje, kterých se uživatel účastnil, s jeho pozicí v globálním žebříčku.
const getUserTournamentRanks = async (userId) => {
  const res = await axiosInstance.get(`/leaderboard/user/${userId}/tournaments`);
  return res.data || [];
};

export default {
	getLeaderboardByTournament,
	getMonthlyLeaderboard,
	getAvailableMonths,
	getUserTournamentRanks,
};